import editor from "./editor";
import commonHelpers from "common/plugins/issues/topic_with_parameter_with_any_value";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
